<template>
  <div class="reading-discount">
    <div class="reading-discount-heading">Membership Discount</div>
    <div class="reading-discount-amount">${{ user.current_reading_discount || 0 }}</div>
    <div class="reading-discount-rollover">
      <div
        v-if="user.current_reading_discount"
        class="reading-discount-rollover-heading"
      >Rollover Discount: ${{ user.rollover_reading_discount || 0 }}</div>
      <div v-else class="reading-discount-rollover-heading">Earn $1.50 for every $1 spent</div>
      <!-- <div class="reading-discount-rollover-amount">$8.50</div> -->
    </div>
    <div class="reading-discount-more">
      Save up to $15 off your membership each month.
      After earning $15, additional savings will rollover to your next month.
    </div>
  </div>
</template>

<script>
export default {
  name: "ReadingDiscount",
  props: ["user"]
};
</script>

<style lang="scss" scoped>
.reading-discount {
  text-align: center;
  font-family: $font-family;
}

.reading-discount-heading {
  padding: 8px;
  border-bottom: 2px solid #eee;
  font-size: 10pt;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.reading-discount-amount {
  padding: 16px 0 12px 0;
  font-size: 24pt;
  font-weight: 600;
}

.reading-discount-rollover {
  padding: 4px 0;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  background: #fff;
}

.reading-discount-rollover-heading {
}

.reading-discount-rollover-amount {
}

.reading-discount-more {
  padding: 9px;
  font-size: 9.5pt;
  color: #666;
  line-height: 1.4em;
}
</style>
